import React from 'react';
import { Container as SemanticContainer } from 'semantic-ui-react';

/*This component facilitates the customization of Container*/

const Container = (props) => {
  return <SemanticContainer {...props} />;
};

export default Container;
